const STORAGE_KEY = 'ocean_shortlist';
export const SHORTLIST_CHANGE_EVENT = 'ocean-shortlist-change';
export const OCEAN_OPEN_SHORTLIST_EVENT = 'ocean-open-shortlist';

// Cached at add-time (from data attributes already on the page's own
// "Add to shortlist" button -- see property-shortlist/src/render.php) so the
// shortlist sidebar can render thumbs/titles straight from localStorage,
// with no extra fetch back to the server.
export interface ShortlistItem
	{
	id: number;
	title: string;
	thumbnail: string;
	permalink: string;
	}

const read = (): ShortlistItem[] =>
	{
	try
		{
		const raw = window.localStorage.getItem(STORAGE_KEY);
		return raw ? JSON.parse(raw) : [];
		}
	catch
		{
		return [];
		}
	};

const write = (items: ShortlistItem[]) =>
	{
	try
		{
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
		}
	catch
		{
		// localStorage unavailable (private mode, storage full, etc.) -- ignore
		}
	window.dispatchEvent(new CustomEvent<ShortlistItem[]>(SHORTLIST_CHANGE_EVENT, { detail: items }));
	};

export const getShortlist = (): ShortlistItem[] => read();

export const isShortlisted = (propertyId: number): boolean => read().some((item) => item.id === propertyId);

export const removeFromShortlist = (propertyId: number): void =>
	{
	write(read().filter((item) => item.id !== propertyId));
	};

// Toggles the given property on/off the shortlist, returning the new state
// (true = now shortlisted). `item` supplies the cached display data and is
// only needed when adding -- removing just needs the id.
export const toggleShortlist = (item: ShortlistItem): boolean =>
	{
	const items = read();
	const index = items.findIndex((existing) => existing.id === item.id);
	if (index === -1)
		{
		items.push(item);
		write(items);
		return true;
		}
	items.splice(index, 1);
	write(items);
	return false;
	};

export const dispatchOpenShortlist = (): void =>
	{
	document.dispatchEvent(new CustomEvent(OCEAN_OPEN_SHORTLIST_EVENT));
	};
